import { useState, useEffect } from "react";
import { isBrowserDefined } from "../services/browserService";

/**
 * Custom hook that tracks the scroll position of the window.
 *
 * @returns {{ x: number, y: number }} - The current scroll position, with `x` for horizontal scroll and `y` for vertical scroll.
 */
const useScrollPosition = (): { x: number; y: number } => {
  const [scrollPosition, setScrollPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (isBrowserDefined()) {
      const handleScroll = () => {
        setScrollPosition({
          x: window.pageXOffset,
          y: window.pageYOffset,
        });
      };
      window.addEventListener("scroll", handleScroll);
      handleScroll();
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);

  return scrollPosition;
};

export default useScrollPosition;
